import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/seo/Seo";
import { categoryList, getCategoryCount } from "../lib/catalog";

const CollectionsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-gray-900 to-black py-6 sm:py-8">
      <Seo
        title="Shop Collections"
        description="Browse JmoLux collections by category, including skincare, haircare, scrub sets, beauty essentials and medical supplies."
        path="/collections"
      />

      <div className="container mx-auto px-4 sm:px-6">
        <div className="mx-auto mb-6 max-w-3xl text-center sm:mb-8">
          <p className="mb-2 text-[9px] uppercase tracking-[0.28em] text-amber-300/80 sm:text-xs">
            Browse by Category
          </p>
          <h1 className="text-2xl font-light tracking-tight text-white sm:text-3xl md:text-4xl">
            Collections built around how your customers actually shop.
          </h1>
          <p className="mt-3 text-xs leading-relaxed text-gray-300 sm:text-sm md:text-base">
            These category pages give search engines and paid campaigns a focused
            destination instead of forcing every visitor onto the homepage.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:gap-4 xl:grid-cols-3">
          {categoryList.map((category, index) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className={`group flex min-w-0 flex-col rounded-xl border border-white/10 bg-white/5 p-3 transition-all duration-300 hover:border-amber-400/30 hover:bg-white/10 sm:rounded-2xl sm:p-5 ${
                categoryList.length % 2 === 1 && index === categoryList.length - 1
                  ? "col-span-2 mx-auto w-[calc(50%-0.375rem)] xl:col-span-1 xl:w-full"
                  : ""
              }`}
            >
              <div className="flex min-w-0 flex-col items-start gap-2 sm:flex-row sm:items-start sm:justify-between">
                <h2 className="text-sm font-light leading-snug text-white sm:text-lg md:text-xl">
                  {category.title}
                </h2>
                <span className="shrink-0 rounded-full border border-amber-400/30 px-2 py-0.5 text-[8px] uppercase tracking-wider text-amber-300 sm:text-[10px]">
                  {getCategoryCount(category.slug)} items
                </span>
              </div>
              <p className="mt-2 line-clamp-3 text-[10px] leading-relaxed text-gray-300 sm:mt-3 sm:text-xs md:text-sm">
                {category.description}
              </p>
              <span className="mt-auto inline-flex items-center pt-3 text-[10px] text-amber-300 transition-transform duration-300 group-hover:translate-x-1 sm:text-xs">
                Explore
                <span aria-hidden="true" className="ml-1">→</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CollectionsPage;
